import React from 'react';


import {ResponsiveElementGroup} from 'src/components/responsive-element-group';
import {FormItemSkeleton, FormSectionSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';

export const AccountInformationSkeleton = () => (
    <FormSectionSkeleton labelWidth={200}>
        <ResponsiveElementGroup>
            <Group direction="v" gap="m" alignItems="start">
                <FormItemSkeleton labelWidth={95}>
                    <SkeletonItem width={320} height={32}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={36}>
                    <SkeletonItem width={320} height={32}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={200}>
                    <SkeletonItem width={320} height={32}/>
                </FormItemSkeleton>
            </Group>
            <Group direction="v" gap="m" alignItems="start">
                <FormItemSkeleton labelWidth={95}>
                    <SkeletonItem width={315} height={32}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={75}>
                    <SkeletonItem width={315} height={32}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={50}>
                    <SkeletonItem width={315} height={32}/>
                </FormItemSkeleton>
            </Group>
            <Group direction="v" gap="m" alignItems="start">
                <FormItemSkeleton labelWidth={55}>
                    <SkeletonItem width={320} height={32}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={45}>
                    <SkeletonItem width={320} height={32}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={45}>
                    <SkeletonItem width={320} height={32}/>
                </FormItemSkeleton>
            </Group>
        </ResponsiveElementGroup>
    </FormSectionSkeleton>
);
